import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { ApiservicesService } from '../../apiservices.service';
import { UserTopComponent } from '../../components/user-top/user-top.component';
import { EncryptdecryptService } from '../../services/encryptdecrypt.service';
import { APP_CONFIG, AppConfig } from '../../app-config';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Carousel } from 'bootstrap';
// import { TranslationService } from '../../services/translation.service';

interface DashboardContent {
  contentId: number;
  contentText: string;
  contentTitle: string | null;
  contentDate: string | null;
  attachmentType: string | null;
  hasAttachment: boolean;
  startingDate: string | Date | null;
}

interface PaparanApiItem {
  contentId: number;
  startingDate: string | null;
  expiryDate: string | null;
  contentText: string | null;
  contentTitle: string | null;
  contentFlag: string | null;
  attachmentType: string | null; // metadata only
  flagAttchment: boolean | null;
  hasError: boolean;
  errMsg: string | null;
}

@Component({
  providers: [UserTopComponent],
  selector: 'app-utama',
  templateUrl: './utama.component.html',
  styleUrls: ['./utama.component.css']
})
export class UtamaComponent implements OnInit, OnDestroy {
  //Session Variables
  SessionFirmID: any = "";
  SessionStaffID: any = "";
  SessionLanguage: any = "";

  //Status Variables
  LoaderStatus: boolean = false;
  isLoadingAnnouncements = true;
  isAttachmentLoading = false;

  //UI View Alert Variables
  AlertType: string = "";
  AlertStatus: boolean = false;
  AlertMessage: string = "";

  // Config property for HTML access
  MyTaxAddress: string = "";
  integrasiCkmTitle: string = '';
  showEWHT!: boolean;
  showEOT!: boolean;

  carouselInstance?: Carousel;
  carouselContents: DashboardContent[] = [];

  selectedAttachment: DashboardContent | null = null;
  selectedAttachmentType: string | null = null; // kept for compatibility
  selectedAttachmentUrl: SafeResourceUrl | null = null;
  private selectedAttachmentBlobUrl: string | null = null;

  selectedAttachmentMimeType: string | null = null;
  selectedAttachmentBlob: Blob | null = null;

  selectedAttachmentDirectUrl: string | null = null;
  attachmentLoadMessage: string = '';

  // cache: contentId -> blob/mime/url
  private attachmentCache = new Map<number, { blob: Blob; mime: string; url: string }>();

  constructor(
    private top: UserTopComponent,
    private encryptDecryptService: EncryptdecryptService,
    private apiServices: ApiservicesService,
    private sanitizer: DomSanitizer,
    // private translationService: TranslationService,
    @Inject(APP_CONFIG) private config: AppConfig
  ) {
    this.MyTaxAddress = config.MyTaxAddress;
    this.integrasiCkmTitle = config.sectionTitles.integrasiCkm;
    this.showEWHT = config.features.showEWHT;
    this.showEOT = config.features.showEOT;
  }

  ngOnInit(): void {
    this.SessionFirmID = this.encryptDecryptService.decrypt(sessionStorage.getItem('FirmID') || '');
    this.SessionStaffID = this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffID') || '');
    // this.SessionLanguage = sessionStorage.getItem('Language');
    this.top.updateTotal();
    this.loadPaparan();

    // // use if we switch to TAeF bilingual later
    // this.translationService.onLangChange().subscribe((lang: string) => {
    //   console.log('Language changed:', lang);

    //   this.SessionLanguage = lang === 'en' ? 'en-MY' : 'ms-MY';

    //   this.updateAnnouncementDates(lang);
    // });
  }

  ngOnDestroy(): void {
    // cleanup selected
    if (this.selectedAttachmentBlobUrl) {
      URL.revokeObjectURL(this.selectedAttachmentBlobUrl);
      this.selectedAttachmentBlobUrl = null;
    }

    // cleanup cache URLs
    this.attachmentCache.forEach((v) => URL.revokeObjectURL(v.url));
    this.attachmentCache.clear();
  }

  // updateAnnouncementDates(lang: string): void {
  //   this.carouselContents = this.carouselContents.map((item) => ({
  //     ...item,

  //     contentDate: this.formatDateByLanguage(
  //       item.startingDate,
  //       lang
  //     )
  //   }));
  // }

  async loadPaparan() {
    this.LoaderStatus = true;

    try {
      const result = await this.apiServices.GetPaparanAsing();
      const paparanList: PaparanApiItem[] = Array.isArray(result?.paparanTAeF) ? result.paparanTAeF : [];

      this.carouselContents = paparanList
        .filter((item) => !result.hasError && !!(item.contentText && item.contentText.trim().length > 0))
        .map((item) => ({
          contentId: item.contentId,
          contentTitle: item.contentTitle,
          startingDate: item.startingDate,
          contentDate: this.formatMalayDate(item.startingDate),
          // contentDate: this.formatDateByLanguage(item.startingDate, this.SessionLanguage === 'en-MY' ? 'en' : 'ms'),
          contentText: (item.contentText || '').replace(/\r?\n/g, '<br>'),
          attachmentType: item.attachmentType,
          hasAttachment: item.flagAttchment === true
        }));

      } catch (error: any) {
      this.AlertType = 'fail';
      this.AlertMessage = error?.error?.message || 'Ralat semasa mendapatkan paparan.';
      this.AlertStatus = true;
      setTimeout(() => (this.AlertStatus = false), 1001);
    } finally {
      this.isLoadingAnnouncements = false;
      this.LoaderStatus = false;
    }
  }

  buildAttachment(attachment: string | null, attachmentType: string | null): string | null {
    if (!attachment) return null;

    if (
      attachment.startsWith('http://') ||
      attachment.startsWith('https://') ||
      attachment.startsWith('./') ||
      attachment.startsWith('assets/') ||
      attachment.startsWith('data:')
    ) {
      return attachment;
    }

    if (attachmentType) {
      return `data:${attachmentType};base64,${attachment}`;
    }

    return attachment;
  }

  hasAttachment(item: DashboardContent): boolean {
    return item.hasAttachment;
  }

  isImageAttachment(item: DashboardContent): boolean {
    // better to use resolved mime first
    if (this.selectedAttachment && this.selectedAttachment.contentId === item.contentId && this.selectedAttachmentMimeType) {
      return this.selectedAttachmentMimeType.startsWith('image/');
    }
    return !!item.attachmentType && item.attachmentType.startsWith('image/');
  }

  private bindPreviewUrl(blobUrl: string, mime: string): void {
    if (mime.includes('pdf')) {
      this.selectedAttachmentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        `${blobUrl}#toolbar=0&navpanes=0&scrollbar=0`
      );
    } else if (mime.startsWith('image/')) {
      this.selectedAttachmentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
    } else {
      this.selectedAttachmentUrl = null;
    }
  }

  setSelectedAttachment(item: DashboardContent): void {
    this.selectedAttachment = item;
    this.selectedAttachmentMimeType = (item.attachmentType || '').toLowerCase();
    this.attachmentLoadMessage = '';
    this.isAttachmentLoading = true;

    const directUrl = this.apiServices.GetPaparanAttachmentAsingUrl(item.contentId);
    this.selectedAttachmentDirectUrl = directUrl;

    if (!this.selectedAttachmentMimeType || this.selectedAttachmentMimeType.includes('pdf')) {
      const iframeUrl = this.selectedAttachmentMimeType.includes('pdf')
        ? `${directUrl}#toolbar=0&navpanes=0&scrollbar=0`
        : directUrl;

      this.selectedAttachmentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(iframeUrl);
    } else {
      this.selectedAttachmentUrl = null;
    }
  }

  onAttachmentPreviewLoaded(): void {
    this.isAttachmentLoading = false;
  }

  onAttachmentPreviewError(): void {
    this.isAttachmentLoading = false;
    this.attachmentLoadMessage = 'Tiada lampiran.';
  }

  clearSelectedAttachment(): void {
    this.selectedAttachment = null;
    this.selectedAttachmentUrl = null;
    this.selectedAttachmentDirectUrl = null;
    this.selectedAttachmentMimeType = null;
    this.selectedAttachmentBlob = null;
    this.selectedAttachmentBlobUrl = null;
    this.attachmentLoadMessage = '';
    this.isAttachmentLoading = false;
  }

  openAttachment(): void {
    if (this.selectedAttachmentDirectUrl) {
      window.open(this.selectedAttachmentDirectUrl, '_blank', 'noopener,noreferrer');
      return;
    }

    if (this.selectedAttachmentBlobUrl) {
      window.open(this.selectedAttachmentBlobUrl, '_blank', 'noopener,noreferrer');
    }
  }

  // Method to navigate to MyTax
  navigateToMyTax() {
    document.location.href = this.MyTaxAddress;
  }

  formatMalayDate(date: string | Date | null): string {
    if (!date) {
      return '';
    }

    return new Intl.DateTimeFormat('ms-MY', {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    }).format(new Date(date));
  }

  // formatDateByLanguage(date: string | Date | null, lang?: string): string {
  //   if (!date) {
  //     return '';
  //   }

  //   const locale = lang === 'en'
  //     ? 'en-US'
  //     : 'ms-MY';

  //   return new Intl.DateTimeFormat(locale, {
  //     day: '2-digit',
  //     month: 'long',
  //     year: 'numeric'
  //   }).format(new Date(date));
  // }
}
